import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { getCatchError } from '../../../getCatchError';

const setPostPinsale = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await DefaultApi({
                params,
                method: 'post',
                url: urls.PINSALE
            });
            alert(data.message);
            
            if (callback) {
                callback();
            }
        } catch (error) {
            getCatchError(error);
        }
    }
}

export {
    setPostPinsale as setPostPinsale
}